<template>
  <div>
    <div v-if="$auth.ready()">
      <v-app :dark="darkTheme">
        <drawer v-if="$auth.check()"></drawer>
        <toolbar></toolbar>
        <v-content>
          <v-container grid-list-xs fluid fill-height>
            <v-layout
              v-if="
                $route.name !== 'signIn' &&
                  $auth.check() &&
                  !$auth.user().client &&
                  !isAdmin() &&
                  !isOperations() &&
                  !isSupplier()
              "
              align-center
              justify-center
            >
              <v-flex xs12 sm8 md4>
                <v-card class="elevation-12">
                  <v-toolbar dark flat color="primary">
                    <v-toolbar-title>Authorization Required</v-toolbar-title>
                    <v-spacer />
                    <v-btn icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-alert
                      outline
                      color="error"
                      icon="warning"
                      :value="true"
                      class="headline"
                    >
                      Sorry! Your are not yet authorized to access
                      <b>{{ $appName }}</b>
                    </v-alert>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="primary" @click.native="contact" flat
                      >Contact {{ $appName }}
                    </v-btn>
                    <v-btn color="error" flat @click.native="signOut"
                      >Sign Out
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
            <router-view v-else />
            <notifications group="all" />
          </v-container>
        </v-content>
        <v-footer app color="primary" dark :fixed="false">
          <v-layout row wrap>
            <v-flex xs6 py-3 text-xs-center white--text>
              &copy;2019 — <strong>www.cube-messenger.com</strong>
            </v-flex>
            <v-flex xs6 py-3 white--text>
              Powered By —
              <strong
                ><a
                  target="_blank"
                  class="accent-4"
                  style="color: #FFFFFF"
                  href="http://thinksynergy.co.ke/"
                  >Think Synergy Limited</a
                ></strong
              >
            </v-flex>
          </v-layout>
        </v-footer>
      </v-app>
    </div>
    <div v-else>
      <loader></loader>
    </div>
  </div>
</template>

<script>
import Loader from './components/Loader'
import Toolbar from './components/Toolbar'
import EventBus from './event-bus'
import Drawer from './components/Drawer'
import Base from './components/Base'
// eslint-disable-next-line import/no-duplicates
import { gmapApi } from 'vue2-google-maps'
// define a mixin object
var mixin = {
  created: function() {
    this.hello()
  },
  methods: {
    hello: function() {}
  },
  computed: {
    google: function() {
      return gmapApi
    }
    // directionsService: new gmapApi.maps.DirectionsService()
  }
}
export default {
  name: 'app',
  mixins: [mixin],
  extends: Base,
  components: {
    Drawer,
    Toolbar,
    Loader
  },
  data: () => ({
    darkTheme: false,
    snackbarNotification: false,
    snackbarNotificationMessage: 'No message specified!'
  }),
  methods: {
    signOut() {
      this.$auth.logout({
        success() {
          this.$app.log('SignOut success')
          this.$vuetify.theme.primary = this.$app.primaryColor
          this.$vuetify.theme.accent = this.$app.accentColor
        },
        error() {
          this.$app.log('SignOut failed')
        }
      })
    },
    contact() {
      this.$app.log(this.$route.name)
      this.$app.log(this.$route.name !== 'signIn')
      this.$app.log(this.$auth.check())
      this.$app.log(this.$auth.user().client)
      this.$app.log(
        this.$route.name !== 'signIn' &&
          this.$auth.check() &&
          !this.$auth.user().client
      )
      this.$app.log(this.$auth.user())
    }
  },
  mounted() {
    let that = this
    EventBus.$on('showSnackbarNotification', function(message, key) {
      that.snackbarNotificationKey = key
      that.snackbarNotification = true
      that.snackbarNotificationMessage = message
    })
    EventBus.$on('closeSnackbarNotification', function(key) {
      if (that.snackbarNotificationKey === key) {
        that.snackbarNotificationKey = null
        that.snackbarNotification = false
        that.snackbarNotificationMessage = null
      }
    })
    EventBus.$on('onThemeSwitch', function(val) {
      that.darkTheme = val
    })
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue